import i18n from "../i18n/i18n";
import {OrderStatusEnum} from "../transportation/models/order";

export default class OrderStatusDropdownItems {
    public static getOrderStatusDropdownItems () {
        return [
            {
                id: OrderStatusEnum.REGISTERED,
                name: i18n.t("orderStatus.REGISTERED")
            },
            {
                id: OrderStatusEnum.CANCELED,
                name: i18n.t("orderStatus.CANCELED")
            },
            {
                id: OrderStatusEnum.PARKING_EXITED,
                name: i18n.t("orderStatus.PARKING_EXITED")
            },
            {
                id: OrderStatusEnum.PARKING_ENTERED,
                name: i18n.t("orderStatus.PARKING_ENTERED")
            },
            {
                id: OrderStatusEnum.CONFIRMED_BY_MANIFEST,
                name: i18n.t("orderStatus.CONFIRMED_BY_MANIFEST")
            },
            {
                id: OrderStatusEnum.DEPO_ENTERED,
                name: i18n.t("orderStatus.DEPO_ENTERED")
            },
            {
                id: OrderStatusEnum.DEPO_EXITED,
                name: i18n.t("orderStatus.DEPO_EXITED")
            },
            {
                id: OrderStatusEnum.FERRY_ENTERED,
                name: i18n.t("orderStatus.FERRY_ENTERED")
            },
            {
                id: OrderStatusEnum.FERRY_EXITED,
                name: i18n.t("orderStatus.FERRY_EXITED")
            }
        ];
    }
}